import { api } from '@/api';
import { APP_TYPE } from '@/api/type';

interface getDownloadCountProps {
    type: APP_TYPE
}

interface getDownloadCountResponse {
    isSuccess: boolean;
    data: {
      count: number
    }
}

/** 다운로드 카운트 조회 */
export const getDownloadCount = async ({type}: getDownloadCountProps) => {
  try {
    const res =
      await api.get<getDownloadCountResponse>(
        `/api/web/visitors/download-records/count/v2`, {
            params: {
              type: type
            }
        }
      );
    return res.data;
  } catch (err) {
    throw err;
  }
};
